import React from "react";
import StyledHome from "../../../utils/styles/StyledHome";
import { ReactSVG } from "react-svg";

import Under from "../assets/30under30.svg";
import Entrepreneur from "../assets/Entrepreneur.svg";
import StyledLeadership from "../styles";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
import Art from "../assets/Group 418@2x.png";
import styled from "styled-components";

const ArtStyles = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
  z-index: 3;
  font-size: 34px;
  align-items: flex-end;
  color: white;
  span {
    font-family: lato;
    margin-bottom: 12px;
    margin-left: 40px;
  }
`;

const Leadership = () => {
  return (
    <>
      <ArtStyles>
        <span>Arthur Souritzidis, CEO</span>
      </ArtStyles>

      <StyledLeadership>
        <ReactSVG
          src={Under}
          beforeInjection={(svg) => {
            svg.classList.add("svgIcon");
          }}
        />
        <ReactSVG
          src={Entrepreneur}
          beforeInjection={(svg) => {
            svg.classList.add("svgIcon");
          }}
        />
      </StyledLeadership>
      <StyledHome>
        <BGImageDisplay
          bgimage={Art}
          options={{
            height: "100%",
            // objpos: "57%",
          }}
        ></BGImageDisplay>
      </StyledHome>
    </>
  );
};

export default Leadership;
